import { pixelsInject } from './module/outstream-pixels';

pixelsInject('').setPubId('tennisnet');
pixelsInject('').setAdTag(
  'https://pubads.g.doubleclick.net/gampad/ads?iu=/22844376944/AA/tennisnet/tennisnet/video/instream&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&env=vp&unviewed_position_start=1&url=[REFERRER_URL]&correlator=&adrule=0&plcmt=2'
);

window.pixelsInject = pixelsInject;
